// extracted by mini-css-extract-plugin
export var root = "_02e994a9c1326407c86458f6bb96efb1-css";
export var inner = "d34a4c3016725711c046257209ff7a9c-css";
export var note = "_92779003889a3678eb35ad0048226d18-css";
export var form = "_5e3bf6602e11ee499d55ba4481ada3ad-css";
export var input = "f0603a624a56070d29c38ee24ad3e235-css";